// はじめて開いたとき（同意）（2026-10-21 に app.js から分けた）
import { S } from './state.js';
import { SERVICE } from './config.js';
import { txt } from './text.js';
import { $ } from './util.js';
import { startTour } from './tour.js';
import { hideBoot } from './boot.js';

// ---- はじめて開いたとき: 利用ガイドライン・利用規約への同意 ----
// 本物の CHOCO の初回確認（chibi.checkFirst・setFirst。ガイドライン・利用規約の吹き出しと START）と同じ印 chibi_agree = "true" を使う
// （本物で同意した人には出さない・モックで同意すれば本物でも出ない）。押すボタンは「同意してはじめる」と「同意して、使い方を見る」の2つだけで、
// 使い方は見たい人だけ（ユーザー判断 2026-10-11。前ははじめて開くと13手順の使い方が自動で始まり、長すぎた）
// 2026-10-18 から: 同意の画面は index.php が読み込みを待たずに出し、ボタンも index.php が受ける（印を残して閉じ、
// charatcreate:agreed を出す・CREATE_AGREED に残す）。ここは画面ができてから「使い方」を始めるだけ
// 2026-10-20 から: 同意の印は CHARAT 全体で1つ（common/js/charat/charat.agree.js の charatAgree。page.php が <head> に書き込む）。
// ほかのメーカーで同意していれば同意の画面は出さず、このメーカーをはじめて開いたとき（CREATE_NEW_HERE）だけ「使い方はここから」を1度出す
export const AGREE_KEY = SERVICE + '_agree';
export function agreed() {
  // 絵を作るだけのモード（?render=1、「声で動かす」の見えない iframe）は人に見せないので、同意を待たずに起動する
  if (window.CREATE_RENDER) return true;
  if (window.charatAgree) return charatAgree.agreed();
  try { return localStorage.getItem(AGREE_KEY) != null; } catch (e) { return true; }
}
export function openFirst() {
  $('first').hidden = false;
  $('firstAgree').focus();
  if (window.CREATE_FIRST) return; // ボタンは index.php が受けている
  // index.php の古い版（同意の画面を出さない・ボタンを受けない）のとき
  const agree = (withTour: boolean) => {
    if (window.charatAgree) charatAgree.set(AGREE_KEY);
    else try { localStorage.setItem(AGREE_KEY, 'true'); } catch (e) {}
    $('first').hidden = true;
    onAgreed(withTour);
  };
  $('firstAgree').onclick = () => { agree(false); };
  $('firstTour').onclick = () => { agree(true); };
}
export function afterAgree(withTour: boolean) {
  if (withTour) startTour();
  else startTour([{ sel: '#btnMenu', title: txt('first_later_title'), text: txt('first_later') }]);
}
export function onAgreed(withTour: boolean) {
  if (S.appShown) afterAgree(withTour); else S.agreedTour = withTour;
  if (S.bootWaitsAgree) { S.bootWaitsAgree = false; hideBoot(); } // 準備ができて、同意を待っていた
}
document.addEventListener('charatcreate:agreed', (e) => { onAgreed(!!e.detail.tour); });
export function appIsShown() {
  S.appShown = true;
  if (S.agreedTour !== null) { afterAgree(S.agreedTour); S.agreedTour = null; }
  else if (window.CREATE_NEW_HERE) { // ほかのメーカーで同意済み・このメーカーははじめて
    window.CREATE_NEW_HERE = false;
    if (window.charatAgree) charatAgree.set(AGREE_KEY);
    afterAgree(false);
  }
}
